import {
  Box,
  SystemProps,
  Text,
  LegacyText,
  TransparentButton,
  Button,
} from "flicket-ui";
import styled from "styled-components";

import { useAtom } from "jotai";
import { Icon } from "~components";
import { ticketDetailsAtom, Details } from "../../common/modal.TicketDetails";
import { googleAnalyticsReleaseAtom } from "~hooks/useGoogleAnalyticsPageView";
import { useOrganization } from "~hooks";
import { trackViewItem } from "~lib/helpers/googleAnalyticsTracking";
import { Info } from "@phosphor-icons/react";

const ToolTip = styled(Box)<SystemProps>`
  position: relative;

  &&& button:hover {
    color: ${(p) => p.theme.colors.N600};
    opacity: 0.8;
    transition:
      background 0.2s,
      box-shadow 0.15s,
      border-color 0.2s,
      color 0.2s,
      opacity 0.2s;
  }
`;

type ListItemDetailsProps = Details & {
  ticketType?: any;
};

export const ListItemDetails = ({
  description,
  restrictions,
  name,
  ticketType,
  ticketImage,
  addonImage,
}: ListItemDetailsProps) => {
  const [, setTicketDetails] = useAtom(ticketDetailsAtom);

  const { organization } = useOrganization();
  const [release] = useAtom(googleAnalyticsReleaseAtom);

  if (!description && !restrictions) {
    return null;
  }

  return (
    <ToolTip>
      <Button
        variant="text-underline"
        onClick={() => {
          //  @ts-expect-error atom type issue while using strict:false
          setTicketDetails({
            name,
            description,
            restrictions,
            ticketImage,
            addonImage,
          });
          trackViewItem({
            currency: organization?.currency,
            id: release?.event?.id,
            name: release?.event?.title,
            ticketType,
            isSeated: true,
            releaseName: release?.name,
            releaseId: release?.id,
          });
        }}
        iconSize="sm"
        color="N600"
        fontSize={2}
      >
        <Info />
        Details
      </Button>
    </ToolTip>
  );
};

export default ListItemDetails;
